import { Api } from 'utils';

class AppoimentService {

  static get = async (params?: any) => Api.createResponse('admin/appoiments/get', params);
  static getDoctorCalendar = async (params?: any) => Api.createResponse('admin/appoiments/doctor/calendar', params);
  static update = async (params?: any) => Api.createResponse('admin/appoiments/update', params);
}

export default AppoimentService;